var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaxHomeSelectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1a2 2 0 0 0-2 2v21.385a2 2 0 0 0 2 2h8.69L18 31l4.31-4.615H31a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H5Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1a2 2 0 0 0-2 2v21.385a2 2 0 0 0 2 2h8.69L18 31l4.31-4.615H31a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H5Z",
    fill: "#20274D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.69 26.385.73-.683-.296-.317h-.435v1ZM18 31l-.73.683.73.782.73-.782L18 31Zm4.31-4.615v-1h-.433l-.297.317.73.683ZM4 3a1 1 0 0 1 1-1V0a3 3 0 0 0-3 3h2Zm0 21.385V3H2v21.385h2Zm1 1a1 1 0 0 1-1-1H2a3 3 0 0 0 3 3v-2Zm8.69 0H5v2h8.69v-2Zm5.04 4.932-4.31-4.615-1.462 1.365 4.311 4.616 1.462-1.366Zm2.85-4.615-4.31 4.615 1.46 1.366 4.312-4.616-1.462-1.365Zm9.42-.317h-8.69v2H31v-2Zm1-1a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2ZM32 3v21.385h2V3h-2Zm-1-1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3v2ZM5 2h26V0H5v2Z",
    fill: "#fff",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.167 14H10.5L18 6.5l7.5 7.5h-1.667M12.167 14v5.833a1.667 1.667 0 0 0 1.666 1.667h8.334a1.667 1.667 0 0 0 1.666-1.667V14",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21.5v-5a1.666 1.666 0 0 1 1.667-1.667h1.666A1.666 1.666 0 0 1 20.5 16.5v5",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaxHomeSelectedIcon);
export default __webpack_public_path__ + "static/media/max-home-selected-icon.0801cb7e570766b9b2171bc939fe07a1.svg";
export { ForwardRef as ReactComponent };